import actionTypes from '../constants/action-types';

const setCustomizationConfiguration = (customization) => ({
  type: actionTypes.SET_CUSTOMIZATION_CONFIGURATION,
  payload: {
    customization,
  },
});

export default setCustomizationConfiguration;
